import {
    SET_PLATFORM_TYPE,
    SET_BROWSER_TYPE,
    UPDATE_CURRENT_TIME,
    LOGOUT_USER,
    EXPIRE_SESSION,
    SET_NVR_TIMESTAMP,
    SET_NVR_TIMEZONE,
    SET_CLOUD_API_VERSION
  } from '../actions/types';

  import moment from 'moment';

  const INITIAL_STATE = {
    platform: '',
    sBrowser: '',
    currentTimeLong: moment(new Date()).format('hh:mm:ss a'),
    currentTimeShort: moment(new Date()).format('hh:mm a'),
    nvrTimestamp: '',
    nvrTimestampShort: '',
    nvrTimezone: '',        // NVR timezone (e.g., "America/Chicago")
    nvrDateFormat: '',      // NVR date format preference
    // Cloud only: the cloudapi build answering this tab now (X-Cloudapi-Version),
    // once a response has named one. Readers fall back to the login's version.
    cloudApiVersion: null
  };
  
  export default function utilityReducer(state = INITIAL_STATE, action) {
    switch ( action.type ) {
      case LOGOUT_USER:
        return {
          ...state,
          // platform and sBrowser are device properties — preserve across logout
          currentTimeLong: moment(new Date()).format('hh:mm:ss a'),
          currentTimeShort: moment(new Date()).format('hh:mm a'),
          nvrTimestamp: '',
          nvrTimestampShort: '',
          nvrTimezone: '',
          nvrDateFormat: '',
          cloudApiVersion: null
        }
      case EXPIRE_SESSION:
        return {
          ...state,
          currentTimeLong: moment(new Date()).format('hh:mm:ss a'),
          currentTimeShort: moment(new Date()).format('hh:mm a'),
          nvrTimestamp: '',
          nvrTimestampShort: '',
          nvrTimezone: '',
          nvrDateFormat: '',
          cloudApiVersion: null
        }
      case SET_PLATFORM_TYPE:
        return { 
          ...state, 
          platform: action.payload 
        }
      case SET_BROWSER_TYPE:
        return { 
          ...state, 
          sBrowser: action.payload 
        }
      case SET_NVR_TIMESTAMP:
        return {
          ...state,
          nvrTimestamp: action.nvrTimestamp,
          nvrTimestampShort: action.nvrTimestampShort
        }
      case SET_NVR_TIMEZONE:
        return {
          ...state,
          nvrTimezone: action.nvrTimezone,
          nvrDateFormat: action.nvrDateFormat || state.nvrDateFormat
        }
      case SET_CLOUD_API_VERSION:
        return { ...state, cloudApiVersion: action.payload || null }
      case UPDATE_CURRENT_TIME:
        return { 
          ...state, 
          currentTimeLong: moment(new Date()).format('hh:mm:ss a'),
          currentTimeShort: moment(new Date()).format('hh:mm a')
        }
      default:
        return state;
    };
  };